// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Components
import { Observer } from "mobx-vue";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class StageLoading extends Vue {}
